
import { locationsData } from '../../../mocks/locations';
import { useState } from 'react';

export default function AreasWeServe() {
  const [hoveredLocation, setHoveredLocation] = useState<number | null>(null);

  return (
    <section id="areas" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-gray-900">Areas We</span>{' '}
            <span className="text-red-500">Serve</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We're proud to help home service contractors grow their businesses across major metropolitan areas nationwide
          </p>
        </div>

        {/* Location Grid - Compact 6 columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {locationsData.map((location, index) => (
            <a
              key={location.id}
              href={`/locations/${location.slug}`}
              className="group relative bg-white rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer border border-gray-200"
              onMouseEnter={() => setHoveredLocation(location.id)}
              onMouseLeave={() => setHoveredLocation(null)}
            >
              {/* Gradient Background - Red to Black */}
              <div className="relative h-24 bg-gradient-to-br from-red-500 to-black flex items-center justify-center transition-all duration-300 group-hover:scale-105">
                {/* City Name Display */}
                <div className="text-center px-3">
                  <h3 className="font-bold text-xl text-white group-hover:scale-110 transition-transform">
                    {location.name}
                  </h3>
                  <p className="text-sm text-white/80 mt-1">{location.state}</p>
                </div>
                
                {/* Decorative Elements */}
                <div className="absolute top-2 right-2 w-12 h-12 bg-white/10 rounded-full blur-2xl"></div>
                <div className="absolute bottom-2 left-2 w-8 h-8 bg-white/10 rounded-full blur-xl"></div>
              </div>

              {/* Location Info */}
              <div className="p-3 bg-white">
                <div className="flex items-center justify-center gap-1 text-red-500 font-semibold text-xs group-hover:gap-2 transition-all">
                  <span>Learn More</span>
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <p className="text-base text-gray-600 mb-5">
            Don't see your city? We're expanding rapidly!
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-red-500 text-white px-7 py-3 rounded-lg font-bold hover:bg-red-600 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            <span>Contact Us Today</span>
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
